// mixin.js
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import URI from 'urijs';

import * as l10n from '@/constants/l10n';

@Component({})
export default class BaseMixin extends Vue {
    public readonly l10n: typeof l10n = l10n;

    public getUrlForImage(
        path: string,
        watermark: boolean = false,
        width: number = 0
    ): string {
        return new URI('/api/file/image')
            .addQuery({
                path,
                watermark: watermark ? 'true' : undefined,
                width: width > 0 ? width : undefined,
            })
            .toString();
    }

    protected get isXlMedia(): boolean {
        // (this as any) necassary because of the missing types for vue-mq
        return (this as any).$mq === 'xl';
    }

    public get isDesktop(): boolean {
        // (this as any) necassary because of the missing types for vue-mq
        return (this as any).$mq === 'lg' || (this as any).$mq === 'xl';
    }
}
